<div style="margin-top: 20px; margin-left: 20px;">
  <form [formGroup]="settingsForm">
    <legend class="settings-section" style="font-weight:bold">Basic Settings</legend>
    <!-- Network Name -->
    <div class="mb-3 row" [ngClass]="{'has-error':!networkName.valid}">
      <span class="col-lg-2">Network Name:</span>
      <div class="col-lg-4">
        <input type="text" class="form-control" [formControl]="networkName" />
      </div>
      <div class="col-lg-4">
        <button type="button" style="margin-left: 20px !important;" pButton title="Rebuild the current networks master indexes"
        label="Rebuild Master" (click)="confirmRebuildMasterNetwork()"></button>
      </div>
    </div>
    @if (networkName.hasError('required')) {
      <div class="mb-3 row">
        <div class="col-lg-6 alert alert-danger">
          Network Name is required
        </div>
      </div>
    }
    <!-- Network Description-->
    <div class="mb-3 row" [ngClass]="{'has-error':!networkDesc.valid}">
      <span class="col-lg-2">Network Description:</span>
      <div class="col-lg-4">
        <input class="form-control" type="text" [formControl]="networkDesc" />
      </div>
    </div>

    <!-- Agent Settings -->
    <legend class="settings-section" style="font-weight:bold">Agent Settings</legend>
    <div class="mb-3 row" [ngClass]="{'has-error':!eventsInterval.valid}">
      <div class="uv-row">
        <span class="col-lg-2">Events Update Interval (seconds):</span>
        <div class="col-lg-1" style="margin-right: 5px;">
          <input class="form-control" type="number" [formControl]="eventsInterval" />
        </div>
        <info width="500px">
          <div style="text-align: left;">
            The frequency at which the web console should poll the server for new events and updated monitor status/data
          </div>
        </info>
      </div>
    </div>
    @if (eventsInterval.hasError('required')) {
      <div class="mb-3 row">
        <div class="col-lg-3 alert alert-danger">
          Events Auto-Update Interval is required
        </div>
      </div>
    }
    @if (eventsInterval.hasError('minValue') || eventsInterval.hasError('maxValue')) {
      <div class="mb-3 row">
        <div class="col-lg-3 alert alert-danger">
          Events Auto-Update Interval must be in the range 15 - 3600
        </div>
      </div>
    }
    <div class="mb-3 row" style="margin-top: 30px;">
      <div class="col-lg-12">
        <input class="auto-update-time" type="checkbox" [formControl]="agentAutoUpdate" />
        <span class="auto-update-time">Automatically update agents between</span>
        <p-calendar formControlName="agentAutoUpdateBeginTime" timeOnly="true" hourFormat="12"
          [ngClass]="{'show-error': !agentAutoUpdateBeginTime.valid || settingsForm.hasError('beginTimePrecedesEndTime')}"
        [disabled]="!enableBeginTime" class="auto-update-time"></p-calendar>
        <span class="auto-update-time">and</span>
        <p-calendar formControlName="agentAutoUpdateEndTime" timeOnly="true" hourFormat="12"
          [ngClass]="{'show-error': !agentAutoUpdateEndTime.valid || settingsForm.hasError('beginTimePrecedesEndTime')}"
        [disabled]="!enableEndTime" class="auto-update-time"></p-calendar>
      </div>
    </div>
    @if (agentAutoUpdateBeginTime.hasError('required')) {
      <div class="mb-3 row">
        <div class="col-lg-3 alert alert-danger">
          Agent auto-update begin time is required
        </div>
      </div>
    }
    @if (agentAutoUpdateEndTime.hasError('required')) {
      <div class="mb-3 row">
        <div class="col-lg-3 alert alert-danger">
          Agent auto-update end time is required
        </div>
      </div>
    }
    <div class="mb-3 row">
      <div class="uv-row">
        <span class="col-lg-2">Agent Installer Location:</span>
        <div class="col-lg-4" style="margin-right: 5px;">
          <input class="form-control" type="text" [formControl]="agentInstallerLocation" />
        </div>
        <info width="500px">
          <div style="text-align: left;">
            By default the agent installer is automatically downloaded from the Web. If you would rather have it be retrieved from a local file path or URL, enter the path or URL here.
          </div>
        </info>
      </div>
    </div>
    <div class="mb-3 row" style="margin-top: 30px;">
      <div class="col-lg-12">
        <input class="" type="checkbox" [formControl]="awolClientAgentsEnabled" (change)="enableDisableControls()" />
        <span class="uv-checkbox-label">Alert when agents do not call in for</span>
        <input class="form-control awol-agents-input" type="number" min="0" max="30" [formControl]="awolClientAgentsDays" />
        <span class="awol-agents-text">days</span>
        <input class="form-control awol-agents-input" type="number" min="0" max="23" [formControl]="awolClientAgentsHours" />
        <span class="awol-agents-text">hours</span>
        <input class="form-control awol-agents-input" type="number" min="0" max="59" [formControl]="awolClientAgentsMinutes" />
        <span class="awol-agents-text">minutes</span>
      </div>
    </div>
    @if (awolClientAgentsDays.hasError('required') || awolClientAgentsDays.hasError('min') || awolClientAgentsDays.hasError('max')) {
      <div
        class="mb-3 row">
        <div class="col-lg-3 alert alert-danger">
          Days value must be in the range 0 - 30
        </div>
      </div>
    }
    @if (awolClientAgentsHours.hasError('required') || awolClientAgentsHours.hasError('min') || awolClientAgentsHours.hasError('max')) {
      <div
        class="mb-3 row">
        <div class="col-lg-3 alert alert-danger">
          Hours value must be in the range 0 - 23
        </div>
      </div>
    }
    @if (awolClientAgentsMinutes.hasError('required') || awolClientAgentsMinutes.hasError('min') || awolClientAgentsMinutes.hasError('max')) {
      <div
        class="mb-3 row">
        <div class="col-lg-3 alert alert-danger">
          Minutes value must be in the range 0 - 59
        </div>
      </div>
    }
    @if (settingsForm.hasError('nonEmptyAwolAgentsSettings')) {
      <div
        class="mb-3 row">
        <div class="col-lg-3 alert alert-danger">
          A non-zero time frame must be specified
        </div>
      </div>
    }
  </form>

  <confirmation-dialog message="Are you sure you want to rebuild this networks master indexes?"
    [display]="displayRebuildMasterNetworkConfirm"
    (onYes)="onRebuildMasterOkClicked()" (onNo)="onRebuildMasterCancelClicked()">
  </confirmation-dialog>
</div>
